export const vacanciesTypes = {
  FETCH_VACANCY_DATA: 'vacancies/GETTING_DATA',
};

export const setVacancies = (vacancies) => ({
  type: vacanciesTypes.FETCH_VACANCY_DATA,
  vacancies,
});
